import { Redirect } from 'react-router-dom';
import { useLatestLandEvent } from '~/components/Land/Event';

export const LandRedirect = () => {
  const latestEvent = useLatestLandEvent();

  return latestEvent?.week ? <Redirect to={`/land/event/${latestEvent.week}`} /> : null;
};
